const selector = require('./selector.js');
const selector_application_section=selector.application_section;

module.exports.find_entry_item = (current_slide_name,strict_name_match=true,item_name) => {
    let selector_entry_item;
    let DOM_entry_item;

    if(strict_name_match){
        selector_entry_item = `${selector_application_section} [data-slide-name="${current_slide_name}"] input[name="${item_name}"]`;
        
    } else {
        selector_entry_item = `${selector_application_section} [data-slide-name="${current_slide_name}"] input[name*="${item_name}"]`;
    }
    DOM_entry_item = document.querySelector(selector_entry_item);

    if(DOM_entry_item == null) throw Error(`item not found(slide:${current_slide_name} item:${item_name})`);
    return DOM_entry_item;
}


module.exports.set_feedback_message = (DOM_check_target,text) => {
    let selector_feekback = `${selector_application_section} [data-for="${DOM_check_target.id}"]`;
    let DOM_feedback=document.querySelector(selector_feekback);
    if(DOM_feedback){
        DOM_feedback.innerText=text;
    }
}

module.exports.disable_tab_stop_in_section = (application_swiper) => {
        
    const selector_target=`${selector_application_section} *`;

    let ary_DOM_target=document.querySelectorAll(selector_target);

    for(var DOM_target of ary_DOM_target){
        DOM_target.tabIndex=-1;
    }
}

module.exports.active_tab_stop_in_active_slide = (application_swiper) => {
    let currentIndex = application_swiper.activeIndex;
    let current_slide_name = application_swiper.slides[currentIndex].dataset['slideName'];


    const ary_selector_item_in_slide = [
        `${selector_application_section} [data-slide-name="${current_slide_name}"] input`,
        `${selector_application_section} [data-slide-name="${current_slide_name}"] textarea`,
        `${selector_application_section} [data-slide-name="${current_slide_name}"] button`,
    ];
    let selector_item_in_slide = ary_selector_item_in_slide.join();

    let ary_DOM_item_in_slide=document.querySelectorAll(selector_item_in_slide);

    for(var DOM_target of ary_DOM_item_in_slide){
        DOM_target.tabIndex=0;
    }
}

module.exports.set_progress = (parcentage) => {
    let DOM_progress = document.querySelector('#application_progress');
    DOM_progress.style.width=`${parcentage}%`;
}

/**
 * fetch()の第一引数に与えるオプション連想配列を生成する
 * 生成は、関数内のデフォルト値と引数で与えられる連想配列をマージして行う
 * 
 * @param {Ojbect} fetch_option fetch()に与えるオプション
 * @returns {Ojbect} fetch()に与えるオプション
 */
module.exports.compose_fetch_option = (fetch_option={}) => {
    let _fetch_option = {
        method: 'POST',
        headers: {
            "Content-Type": "application/x-www-form-urlencoded"
        },
        mode: 'cors',
        credentials: 'include' // クッキーの送信
    };
    
    _fetch_option = {..._fetch_option , ...fetch_option};

    return _fetch_option;
};

const compose_ajax_sub_simple_request = (option={}) => {
    let {fetch_option,url} = option;

    //ハンドラ
    let {form_data_acquire,closing} = option;
    const compose_fetch_option = module.exports.compose_fetch_option;
    /*
        ファサード関数でチェック済みなのでここではチェックなし
    */
    let _fetch_option = compose_fetch_option(fetch_option);
    
    return ()=>{
        let routine = Promise.resolve();
        if(url){
            routine = routine.then(
                ()=>{
                    _fetch_option.body = form_data_acquire.call(null);
                    return fetch(url, _fetch_option);
                }
            );
            routine = routine.then(
                (response)=>{
                    return response.json();
                }
            );
        }
        routine = routine.then(
            (json)=>{
                closing.call(null,json);
            }
        );
        routine = routine.catch(
            (err)=>{
                throw err;
            }
        );

        return routine;
    }
    
}

const compose_ajax_sub_operate_query = (option={}) => {

    let {fetch_option,verify_url,operation_url} = option;
    const compose_fetch_option = module.exports.compose_fetch_option;
    //ハンドラ
    let {form_data_verify,form_data_operation,closing} = option;

    /*
        ファサード関数でチェック済みなのでここではチェックなし
    */
    
    let _fetch_option = compose_fetch_option(fetch_option);

    return ()=>{
        let routine = Promise.resolve();
        if(verify_url){
            routine = routine.then(
                ()=>{
                    _fetch_option.body = form_data_verify.call(null);
                    return fetch(verify_url, _fetch_option);
                }
            );
            routine = routine.then(
                (response)=>{
                    return response.json();
                }
            );
        }
        if(operation_url){
            routine = routine.then(
                (json)=>{
                    _fetch_option.body = form_data_operation.call(null,json,_fetch_option.body);
                    return fetch(operation_url, _fetch_option);
                }
            );
            routine = routine.then(
                (response)=>{
                    return response.json();
                }
            );
        }
        routine = routine.then(
            (json)=>{
                closing.call(null,json);
            }
        );
        routine = routine.catch(
            (err)=>{
                throw err;
            }
        );

        return routine;
    }

}

/**
 * exprで表される式が呼び出し可能なオブジェクトを表すかチェックする。
 * @param { * } expr オブジェクトを表す式
 * @returns { boolean } 式 expr が 呼び出し可能ならtrue
 */
module.exports.is_callable = (expr) => {
    return [
        (expr),
        (typeof expr === 'function')
    ].every(e=>e);

}


module.exports.compose_ajax = (option={}) => {

    //ハンドラ
    let {form_data_verify,form_data_acquire,form_data_operation,closing} = option;
    const is_callable=module.exports.is_callable;
    let mode="";
    
    if(is_callable(form_data_acquire)) mode = "simple_request";
    if(is_callable(form_data_verify)) mode = "operate_query";

    if(closing){
        if(is_callable(closing) === false){
            throw Error(`compose_ajax : field 'closing' must be callable object`);
        }
    }

    switch(mode){
        case "operate_query":
                if(is_callable(form_data_verify) === false){
                    throw Error(`compose_ajax : field 'form_data_verify' must be callable object`);
                }
                if(form_data_operation){
                    if(is_callable(form_data_operation) === false){
                        throw Error(`compose_ajax : field 'form_data_operation' must be callable object`);
                    }
                }
                return compose_ajax_sub_operate_query(option);
        case "simple_request":
            if(is_callable(form_data_acquire) === false){
                throw Error(`compose_ajax : field 'form_data_acquire' must be callable object`);
            }
            return compose_ajax_sub_simple_request(option);
        default:
            throw Error(`compose_ajax : field 'form_data_verify' or 'form_data_acquire' must be callable object`);            
    }


}
